
import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import loaderGif from "../../src/Images/loader.gif";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";
import { useParams } from "react-router-dom";
import Nav from "./Navbar";
import Footer from "./Footer";
import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
import { basicauth, basicauthblog } from "../Utils/Credentials";
import { AiOutlineEye } from "react-icons/ai";
import { GlobalContext } from "../Context/GlobalState";
const normalizeBlogResponse = (apiData) => {
  if (!apiData) return null;

  const blog = Array.isArray(apiData) ? apiData[0] : apiData;
  if (!blog) return null;

  return {
    id: blog.id || "",
    title: blog.title || "",
    excerpt: blog.excerpt || "",
    image_url: blog.image_url || "",
    image_desc: blog.image_desc || blog.title || "",
    keyword: blog.keyword || "",
    tag: blog.tag || "",
    slug: blog.slug || "",
    in_time: blog.in_time || "",
    views: blog.views || "0",
    author_name: blog.author_name || "Unknown",
    author_slug: blog.author_slug || "",
    author_url: blog.author_url || "",
    category_name: blog.category_name || "",
    sub_category: blog.sub_category || "",

    blocks: Array.isArray(blog.blocks)
      ? blog.blocks
          .sort((a, b) => Number(a.block_order) - Number(b.block_order))
          .filter((b) => b && (b.block_content || b.block_image))
          .map((b) => ({
            block_type: (b.block_type || "p").toLowerCase(),
            block_content: b.block_content || "",
            block_image: b.block_image || "",
            block_image_alt: b.block_image_alt || "",
            block_image_desc: b.block_image_desc || "",
            block_image_title: b.block_image_title || "",
            block_order: b.block_order || 0,
          }))
      : [],
  };
};

const Article = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [blogData, setBlogData] = useState(null);
  const [postdata, setpostdata] = useState([]);
  const { post_slug } = useParams();
  const { password, username } = basicauthblog;
  const base64Credentials = btoa(`${username}:${password}`);
  const {  setTransactionLoaderState } = useContext(GlobalContext);
  const GetAuthorsBlog = async (slug) => {
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ slug: slug }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetProductBlogBySlug`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0") {
        const normalized = normalizeBlogResponse(data.data);
        setBlogData(normalized);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    if (post_slug) {
      GetAuthorsBlog(post_slug);
    }
  }, [post_slug]);
  const Getproductblogs = async () => {
    setIsLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          webid: "1",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetAllProductBlog`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        setpostdata(data.data || []);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (blogData) {
      const images = document.querySelectorAll(".blog-content img");
      images.forEach((img) => {
        img.style.borderRadius = "1rem";
        img.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
        img.style.width = "100%";
        img.style.height = "auto";
      });
    }
  }, [blogData]);

  useEffect(() => {
    Getproductblogs();
  }, []);

  if (!blogData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <img src={loaderGif} alt="Loading..." style={{ width: "" }} />
      </div>
    );
  }
  function cleanBlockContent(htmlString) {
    return htmlString.replace(/<\/?span[^>]*>/g, "");
  }

  const blogUrl = `https://seobix.com/blog/${blogData.slug}`;
  console.log("OG IMAGE:", blogData.image_url);
  return (
    <>
     {/* {blogData && (
  <Helmet key={blogData?.image_url || blogData?.slug}>
   
    <title>{blogData.title} | SeoBix Blog</title>
    <meta name="title" content={`${blogData.title} | SeoBix Blog`} />
    <meta
      name="description"
      content={
        blogData.excerpt || "Read this in-depth article on SeoBix Blog."
      }
    />
    <meta
      name="keywords"
      content={
        blogData.keyword || "SEO, SeoBix, Blog, Digital Marketing"
      }
    />
    <meta name="author" content={blogData.author_name || "SeoBix"} />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href={blogUrl} />

    
    <meta property="og:type" content="article" />
    <meta property="og:url" content={blogUrl} />
    <meta property="og:title" content={blogData.title} />
    <meta
      property="og:description"
      content={blogData.excerpt || "SeoBix Blog article"}
    />

    {blogData.image_url && (
      <meta
        property="og:image"
        content={String(blogData.image_url).trim()}
      />
    )}

    {blogData.image_url && (
      <meta
        property="og:image:secure_url"
        content={String(blogData.image_url).trim()}
      />
    )}

    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />

   
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={blogData.title} />
    <meta
      name="twitter:description"
      content={blogData.excerpt || ""}
    />

    {blogData.image_url && (
      <meta
        name="twitter:image"
        content={String(blogData.image_url).trim()}
      />
    )}

  
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: blogData.title || "",
        description: blogData.excerpt || "",
        image: blogData.image_url || "",
        author: {
          "@type": "Person",
          name: blogData.author_name || "SeoBix",
        },
        publisher: {
          "@type": "Organization",
          name: "SeoBix",
          logo: {
            "@type": "ImageObject",
            url: "https://seobix.com/logo192.png",
          },
        },
        datePublished: blogData.published_at || "",
        dateModified:
          blogData.updated_at || blogData.published_at || "",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": blogUrl,
        },
      })}
    </script>

   
    <script src="https://seobix.com/schemaScript/jsonseobix.js" />
  </Helmet>
)} */}
<Helmet>
  <title>{blogData.title}</title>
  <meta name="description" content={blogData.excerpt || ""} />
</Helmet>
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        <div>
          <Nav />
        </div>

        <Row className="d-flex justify-content-center mt-2 m-md-0 m-2">
          <Col className="col-md-10 col-12">
            <div className="row " style={{ height: "auto", marginTop: "3rem" }}>
              <div
                className="col-md-9 col-12  "
                style={{
                  // height: "120vh",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <style>
                  {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}
                </style>

                <div style={{ width: "95%" }}>
                  <div className="d-flex flex-wrap"></div>

                  <h1>{blogData.title}</h1>

                  <div className="row mt-4">
                    <p
                      className="col"
                      style={{
                        fontSize: ".9rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {blogData.author_url ? (
                        <img
                          src={blogData.author_url}
                          alt={blogData.author_url}
                          style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginRight: "8px",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "inline-block";
                          }}
                        />
                      ) : (
                        <FaUserTie
                          style={{
                            fontSize: "1.3rem",
                            color: "grey",
                            marginRight: "8px",
                          }}
                        />
                      )}

                      <FaUserTie
                        style={{
                          fontSize: "1.3rem",
                          color: "grey",
                          marginRight: "8px",
                          display: "none",
                        }}
                      />

                      <Link
                        to={`/author/${blogData.author_slug}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                        }}
                        onClick={() => {
                          const authorData = JSON.stringify(blogData);
                          console.log("click hua");
                          localStorage.setItem("author", authorData);
                        }}
                      >
                        {blogData.author_name}
                      </Link>
                    </p>

                    <p
                      className="col d-flex justify-content-end align-items-center gap-3 "
                      style={{ fontSize: ".9rem", color: "#6b7280" }}
                    >
                      {/* Date */}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <AiOutlineEye style={{ fontSize: "1.2rem" }} />
                        {blogData.in_time
                          ? new Date(blogData.in_time).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }
                            )
                          : new Date().toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })}
                      </span>

                      {/* Views */}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <AiOutlineEye style={{ fontSize: "1.2rem" }} />
                        {blogData.views ?? 0}
                      </span>
                    </p>
                  </div>

                  <img
                    className="mt-3 mb-5"
                    src={blogData.image_url}
                    alt={blogData.image_desc}
                    title={blogData.image_desc}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "1rem",
                    }}
                  />

                  <p className="mt-5" style={{ fontSize: "1rem" }}>
                    {blogData.excerpt}
                  </p>
                  <div className="blog-content mt-3">
                    <style>
                      {`
      .blog-content a {
        text-decoration: none;
      }

      .blog-content a:hover {
        text-decoration: underline;
      }
    `}
                    </style>

                    {(() => {
                    const renderedContents = new Set();

                    return blogData.blocks?.map((block, index) => {
                      const cleanedContent = cleanBlockContent(
                        block.block_content || ""
                      );

                      const type = block.block_type.toLowerCase();
                      if (type === "h1" && index === 0) {
                        return null;
                      }
                      
                      if ((type === "ul" || type === "ol") && cleanedContent) {
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = cleanedContent;
                        const paragraphs = Array.from(
                          tempDiv.querySelectorAll("p")
                        );
                        paragraphs.forEach((p) =>
                          renderedContents.add(p.innerHTML.trim())
                        );
                      }

                      if (
                        type === "p" &&
                        renderedContents.has(cleanedContent.trim())
                      ) {
                        return null;
                      }

                      const supportedTags = [
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6",
                        "p",
                        "ul",
                        "ol",
                        "li",
                        "blockquote",
                        "code",
                        "pre",
                        "div",
                        "span",
                        "strong",
                        "em",
                        "u",
                        "img",
                        "video",
                        "a",
                        "br",
                      ];

                      if (
                        (type === "p" || type.startsWith("h")) &&
                        cleanedContent.includes("<img") &&
                        blogData.blocks[index + 1]?.block_type.toLowerCase() ===
                          "img"
                      ) {
                        const nextImg = blogData.blocks[index + 1].block_image;
                        const match = cleanedContent.match(
                          /<img[^>]+src="([^"]+)"/i
                        );
                        if (match && match[1] === nextImg) return null;
                      }

                      if (type === "img" && block.block_image) {
                        return (
                          <div key={index} className="my-3 text-center">
                            <img
                              src={block.block_image}
                              alt={block.block_image_alt || ""}
                              title={block.block_image_title || ""}
                              className="img-fluid"
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                              }}
                            />
                            {block.block_image_desc && (
                              <p
                                className="mt-2 text-muted"
                                style={{ fontStyle: "" }}
                              >
                                {block.block_image_desc}
                              </p>
                            )}
                          </div>
                        );
                      }
                      // FAQ Rendering
                      if (type === "faq_question") {
                        return (
                          <div
                            key={index}
                            style={{
                              background: "#f3f4f6",
                              padding: "12px 16px",
                              borderRadius: "8px",
                              marginTop: "16px",
                              fontWeight: "600",
                              borderLeft: "4px solid #6366f1",
                            }}
                          >
                            Q. {cleanedContent}
                          </div>
                        );
                      }

                      if (type === "faq_answer") {
                        return (
                          <div
                            key={index}
                            style={{
                              background: "#ffffff",
                              padding: "12px 16px",
                              borderRadius: "8px",
                              marginBottom: "12px",
                              borderLeft: "4px solid #22c55e",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                            }}
                          >
                            <strong>A.</strong> {cleanedContent}
                          </div>
                        );
                      }

                      if (supportedTags.includes(type)) {
                        return (
                          <div
                            key={index}
                            dangerouslySetInnerHTML={{
                              __html: `<${type}>${cleanedContent}</${type}>`,
                            }}
                          />
                        );
                      }

                      return (
                        <p
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: cleanedContent,
                          }}
                        />
                      );
                    });
                  })()}
                  </div>

                  <div className="" style={{ marginTop: "3rem" }}>
                    {[...(blogData.keyword || "").split(",")].map(
                      (keyword, index) =>
                        keyword.trim() && (
                          <span
                            key={index}
                            className="me-2 mb-2 d-inline-block"
                            style={{
                              backgroundColor: "#f0f0f0",
                              border: "1px solid #b0b0b0",
                              color: "#333",
                              borderRadius: ".2rem",
                              fontSize: ".8rem",
                              padding: "0.25rem 0.5rem",
                              marginLeft: ".4rem",
                            }}
                          >
                            {keyword.trim()}
                          </span>
                        )
                    )}
                  </div>
                  <div
                    className=" px-2"
                    style={{ marginTop: "3rem", marginBottom: "6rem" }}
                  >
                    {(blogData.tag || "")
                      .split(",")
                      .filter((tag) => tag.trim())
                      .map((tag, index) => (
                        <Link
                          key={index}
                          to="/blog"
                          onClick={() => {
                            sessionStorage.setItem(
                              "tag",
                              JSON.stringify(tag.trim())
                            );
                            sessionStorage.setItem("FromTag", "1");
                          }}
                          className="me-2 mb d-inline-block text-decoration-none px-2"
                        >
                          #{tag.trim()}
                        </Link>
                      ))}
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-12 p-md-0 p-5">
                <div className="text-center mb-4">
                  <h6
                    className="fw-bold position-relative d-inline-block"
                    style={{
                      fontSize: "1rem",
                      padding: "0 1rem",
                      color: "#333",
                    }}
                  >
                    Trending Now
                    <span
                      style={{
                        display: "block",
                        height: "3px",
                        width: "50%",
                        backgroundColor: "#0d6efd",
                        margin: "4px auto 0",
                        borderRadius: "2px",
                      }}
                    ></span>
                  </h6>
                </div>

                <div
                  className="related-blogs-scroll mt-4"
                  style={{ paddingRight: "10px" }}
                >
                  {postdata
                    .slice(-12)
                    .reverse()
                    .map((blog) => (
                      <div key={blog.id} className="mb-3">
                        <a
                          href={`/blog/${blog.slug}`}
                          onClick={() =>
                            sessionStorage.setItem("Slug", JSON.stringify(blog))
                          }
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <img
                            src={blog.image_url}
                            alt={blog.image_alt || "Blog Image"}
                            className="img-fluid rounded shadow-sm mb-2"
                            style={{
                              width: "100%",
                              transition: "transform 0.3s",
                            }}
                          />
                          <p
                            className="mb-0"
                            style={{
                              fontSize: ".85rem",
                              fontWeight: 500,
                              color: "#000",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {blog.title}
                          </p>
                        </a>
                      </div>
                    ))}
                </div>

                <style>
                  {`
      .related-blogs-scroll::-webkit-scrollbar {
        display: none;
      }
      .related-blogs-scroll {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }
      .related-blogs-scroll img:hover {
        transform: scale(1.03);
      }
    `}
                </style>
              </div>
            </div>
          </Col>
        </Row>
        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background:
              "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        >
          <Footer />
        </div>
      </Container>
    </>
  );
};

export default Article;
